import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select } from "antd";
import { useEffect, useMemo, useState } from "react";
import { DEFAULT_LANGUAGE, isLanguageAllowed } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../../others/i18n.js";
import { useStores } from "../../../../../../store/root.js";
import { getSupportedLanguageOptions } from "../../../../../../util/template/translation.js";
function getLanguageOption(language) {
    return /*#__PURE__*/ _jsx(Select.Option, {
        value: language.value,
        label: language.label,
        children: /*#__PURE__*/ _jsxs("div", {
            style: {
                display: "flex",
                alignItems: "baseline"
            },
            children: [
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        marginRight: 8
                    },
                    children: language.icon
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: language.label
                })
            ]
        })
    }, language.value);
}
function useLanguageOptions(t) {
    return getSupportedLanguageOptions(t).map((language)=>({
            value: language.language,
            label: language.label,
            icon: language.icon
        }));
}
function LanguageSelect({ onChange, value, disabled = false, excludedLang = [], mode = undefined, placeholder = undefined, style = undefined, allowClear = false }) {
    const { t } = useTranslation();
    const { rcbAuthenticationStore } = useStores();
    const { session } = rcbAuthenticationStore;
    const languages = useMemo(()=>useLanguageOptions(t), [
        t
    ]);
    const [options, setOptions] = useState([]);
    useEffect(()=>{
        setOptions(languages.filter((language)=>!excludedLang.includes(language.value) && isLanguageAllowed(session?.user, language.value)));
    }, [
        excludedLang,
        session?.user
    ]);
    return /*#__PURE__*/ _jsx(Select, {
        defaultValue: DEFAULT_LANGUAGE,
        popupMatchSelectWidth: false,
        dropdownStyle: {
            minWidth: "auto"
        },
        onChange: (value, option)=>onChange?.(value, option),
        disabled: disabled,
        optionLabelProp: "children",
        value: value,
        mode: mode,
        placeholder: placeholder,
        style: style,
        allowClear: allowClear,
        filterOption: (input, option)=>(option?.label?.toString()?.toLowerCase() ?? "").includes(input.toLowerCase()),
        optionFilterProp: "label",
        children: options.map((language)=>getLanguageOption(language))
    });
}
export { LanguageSelect, getLanguageOption, useLanguageOptions };
